import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorToolsTextService {


  constructor() {
  }

  public createText(el, x, y, opts) {
    const item = document.createElement('textarea');
    item.id = ('text' + Math.random() * Math.random() * 1000).replace('.', '');
    item.style.position = 'absolute';
    item.style.left = (x / el.clientWidth * 100) + '%';
    item.style.top = (y / el.clientHeight * 100) + '%';
    item.style.width = 100 + 'px';
    item.style.height = 50 + 'px';
    item.style.overflow = 'visible';
    item.style.resize = 'both';
    item.draggable = true;
    item.style.backgroundColor = 'transparent';
    item.style.lineHeight = '0.8';
    item.style.color = opts.color && opts.color.hex ? opts.color.hex : '#000000';
    item.value = 'Text';
    item.style.fontFamily = '"Open Sans", sans-serif';
    item.style.fontWeight = '500';
    item.style.fontSize = (30 * 0.75) + 'px';

    item.ondragstart = function(e) {
      (e['srcElement'] as HTMLElement).setAttribute('data-dragstart-x', (e['offsetX'] / window.devicePixelRatio).toString());
      (e['srcElement'] as HTMLElement).setAttribute('data-dragstart-y', (e['offsetY'] / window.devicePixelRatio).toString());
    };
    item.ondragend = function(e) {
      item.style.left = ( (e['target']['offsetLeft'] + e['offsetX'] - parseFloat(e['target']['dataset']['dragstartX'])) / el.clientWidth * 100 ) + '%';
      item.style.top = ( (e['target']['offsetTop'] + e['offsetY'] - parseFloat(e['target']['dataset']['dragstartY'])) / el.clientHeight * 100 ) + '%';
    };
    item.onmousemove = function(e) {
      if (
        (e['offsetX'] >= -2) && (e['offsetX'] <= 2) ||
        (e['offsetX'] >= (e['target']['offsetWidth'] - 2)) && (e['offsetX'] <= e['target']['offsetWidth'] + 2) ||
        (e['offsetY'] >= -2) && (e['offsetY'] <= 2) ||
        (e['offsetY'] >= (e['target']['offsetHeight'] - 2)) && (e['offsetY'] <= e['target']['offsetHeight'] + 2)) {
        e['target']['style']['cursor'] = 'move';
      } else {
        e['target']['style']['cursor'] = 'text';
      }
    };

    const script = null;
    return { item, script };
  }

}
